import { useLocation } from 'react-router-dom'
import { BRANCH_BASE_URL, MAIN_PLL_URL } from '../Config/config'

export const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export type DynamicLinkParam = {
  title: string
  value?: string | number
}

export const createDynamicLink = (
  params: DynamicLinkParam[],
  pageId: string,
  webUrl?: string,
  socialParams?: SocialParams
) => {
  const webLink = webUrl || `https://${MAIN_PLL_URL}/`
  const paramsForLongLink = [...params, { title: 'pageID', value: pageId }]
  const dLink = createLongLink(webLink, paramsForLongLink, socialParams)
  return dLink
}

type SocialParams = {
  title?: string
  description?: string
  image?: string
}

export const createLongLink = (link: string, params: DynamicLinkParam[], socialParams?: SocialParams) => {
  let linkParams = `?$canonical_url=${encodeURIComponent(link)}`
  if (params.length > 0) {
    linkParams += createLinkDataString(params)
  }
  if (socialParams) {
    if (socialParams.title) {
      const title = encodeURIComponent(socialParams.title)
      linkParams += `&$og_title=${title}`
      linkParams += `&$twitter_title=${title}`
    }
    if (socialParams.description) {
      const description = encodeURIComponent(socialParams.description)
      linkParams += `&$og_description=${description}`
      linkParams += `&$twitter_description=${description}`
    }
    if (socialParams.image) {
      const image = encodeURIComponent(socialParams.image)
      linkParams += `&$og_image_url=${image}`
      linkParams += `&$twitter_image_url=${image}`
    }
  }
  if (linkParams.endsWith('&')) linkParams = linkParams.slice(0, -1)

  return `${BRANCH_BASE_URL}/${linkParams}`
}

const createLinkDataString = (params: DynamicLinkParam[]) => {
  if (params.length < 1) {
    return ''
  }
  let str = ''
  params.map((item) => {
    if (item.value) {
    str += `&${item.title}=${item.value}`
    }
  })
  return str
}
